module.exports = __webpack_public_path__ + "img/live.da074e9.png";